// Посадочная страница: что видит человек, пришедший по ссылке из резюме.
// Раньше первым экраном была форма входа — рекрутёр и технический интервьюер
// закрывали вкладку, не увидев ничего. Здесь продукт объясняется за два
// предложения, а ниже идёт технический разбор: для интервьюера это мини-
// портфолио, которое рассказывает больше, чем строка в резюме.
import { useSettings } from '../context/SettingsContext.jsx';

const ACC = 'var(--app-accent,#c9a24b)';
const BORD = 'var(--app-border,#1f1f25)';
const DIM = 'var(--app-dim,#8a8a92)';
const SERIF = "'Cormorant Garamond', Georgia, serif";

// Содержимое идёт через словарь: раньше оно было зашито по-русски, и при
// английском интерфейсе переводились только заголовки — страница выходила
// наполовину русской.
const FEATURE_KEYS = [
  ['❤️', 'lp_f1_t', 'lp_f1_d'],
  ['🏃', 'lp_f2_t', 'lp_f2_d'],
  ['🎯', 'lp_f3_t', 'lp_f3_d'],
  ['📚', 'lp_f4_t', 'lp_f4_d'],
  ['📝', 'lp_f5_t', 'lp_f5_d'],
  ['🤖', 'lp_f6_t', 'lp_f6_d'],
];

const TECH_KEYS = [
  ['lp_t1_l', 'lp_t1_b'],
  ['lp_t2_l', 'lp_t2_b'],
  ['lp_t3_l', 'lp_t3_b'],
  ['lp_t4_l', 'lp_t4_b'],
  ['lp_t5_l', 'lp_t5_b'],
  ['lp_t6_l', 'lp_t6_b'],
];

export default function LandingPage({ onEnter }) {
  const { t, lang, setLang } = useSettings();
  return (
    <div style={{ minHeight: '100vh', background: 'var(--app-bg,#0d0d10)', color: 'var(--app-text,#ece6d6)' }}>
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '48px 20px 60px' }}>

        {/* Что это — за два предложения */}
        {/* Переключатель языка прямо на витрине: до входа настроек нет,
            а гость может не владеть языком, который угадал браузер. */}
        <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end', marginBottom: 14, flexWrap: 'wrap' }}>
          {[['en', 'EN'], ['ru', 'RU'], ['es', 'ES'], ['de', 'DE'], ['ar', 'AR']].map(([code, label]) => (
            <button key={code} onClick={() => setLang(code)}
              style={{ padding: '4px 9px', borderRadius: 8, fontSize: 11, fontFamily: 'inherit', cursor: 'pointer',
                       border: `1px solid ${lang === code ? 'var(--app-border-gold,#2a2418)' : BORD}`,
                       background: lang === code ? 'var(--app-accent-wash,#1a160c)' : 'transparent',
                       color: lang === code ? ACC : DIM, fontWeight: lang === code ? 700 : 400 }}>{label}</button>
          ))}
        </div>

        <div style={{ fontSize: 10.5, letterSpacing: '.2em', textTransform: 'uppercase', color: ACC, fontWeight: 700 }}>
          {t('lp_kicker', 'персональный проект · 2026')}
        </div>
        <h1 style={{ fontFamily: SERIF, fontSize: 'clamp(32px,7vw,54px)', fontWeight: 400, margin: '12px 0 16px', lineHeight: 1.1 }}>
          {t('lp_title', 'Приложение, где тело и голова в одном месте')}
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.6, color: 'var(--app-body,#cfcabb)', maxWidth: 640, margin: '0 0 10px' }}>
          {t('lp_sub', 'Данные с часов приходят сами: сон, пульс покоя, тренировки. Рядом — цели, фокус-сессии, учебники и заметки. Приложение показывает, как одно влияет на другое.')}
        </p>
        <p style={{ fontSize: 13.5, lineHeight: 1.6, color: DIM, maxWidth: 640, margin: '0 0 26px' }}>
          {t('lp_users', 'Работает в продакшене. Им пользуются люди трёх поколений — от четырнадцати до шестидесяти.')}
        </p>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 44 }}>
          <button onClick={onEnter}
            style={{ padding: '12px 24px', borderRadius: 12, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
                     background: 'var(--app-accent-grad,linear-gradient(135deg,#e8cf8a,#c9a24b))', color: '#0d0d10', fontSize: 14, fontWeight: 700 }}>
            {t('lp_enter', 'Войти или создать аккаунт')}
          </button>
          <a href="#tech"
            style={{ padding: '12px 20px', borderRadius: 12, border: `1px solid ${BORD}`, textDecoration: 'none',
                     color: DIM, fontSize: 14, fontWeight: 600, display: 'inline-block' }}>
            {t('lp_tech_link', 'Как устроено технически ↓')}
          </a>
        </div>

        {/* Что внутри */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 12, marginBottom: 48 }}>
          {FEATURE_KEYS.map(([icon, kt, kd]) => (
            <div key={kt} style={{ border: `1px solid ${BORD}`, borderRadius: 14, padding: '15px 16px',
                                     background: 'var(--app-card-grad,linear-gradient(160deg,#121216,#0d0d10))' }}>
              <div style={{ fontSize: 19, marginBottom: 6 }}>{icon}</div>
              <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 5 }}>{t(kt)}</div>
              <div style={{ fontSize: 12.5, lineHeight: 1.55, color: DIM }}>{t(kd)}</div>
            </div>
          ))}
        </div>

        {/* Технический разбор — ради технического интервьюера */}
        <div id="tech" style={{ scrollMarginTop: 20 }}>
          <div style={{ fontSize: 10.5, letterSpacing: '.2em', textTransform: 'uppercase', color: ACC, fontWeight: 700, marginBottom: 14 }}>
            {t('lp_tech', 'как это устроено')}
          </div>
          {TECH_KEYS.map(([kl, kb]) => (
            <div key={kl} style={{ display: 'flex', gap: 16, padding: '14px 0', borderTop: `1px solid ${BORD}`, flexWrap: 'wrap' }}>
              <div style={{ flex: '0 0 120px', fontSize: 12.5, fontWeight: 700, color: ACC }}>{t(kl)}</div>
              <div style={{ flex: '1 1 320px', fontSize: 13, lineHeight: 1.6, color: 'var(--app-body,#cfcabb)' }}>{t(kb)}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 40, paddingTop: 20, borderTop: `1px solid ${BORD}`, fontSize: 12, color: 'var(--app-dimmer,#5a5a62)', lineHeight: 1.6 }}>
          {t('lp_foot', 'Личный проект. Данные каждого пользователя изолированы, рекламы и сторонних трекеров нет.')}
          <div style={{ marginTop: 12 }}>
            <button onClick={onEnter}
              style={{ padding: '10px 20px', borderRadius: 10, border: `1px solid ${BORD}`, background: 'transparent',
                       color: ACC, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
              {t('lp_enter', 'Войти или создать аккаунт')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
